__turbopack_context__.v({
  "dialogBody": "ChangeOriginModal-module__lYh4dW__dialogBody",
  "dialogCancel": "ChangeOriginModal-module__lYh4dW__dialogCancel",
  "dialogFooter": "ChangeOriginModal-module__lYh4dW__dialogFooter",
  "dialogList": "ChangeOriginModal-module__lYh4dW__dialogList",
  "dialogListHeading": "ChangeOriginModal-module__lYh4dW__dialogListHeading",
  "dialogOption": "ChangeOriginModal-module__lYh4dW__dialogOption",
  "dialogOptionLabel": "ChangeOriginModal-module__lYh4dW__dialogOptionLabel",
  "dialogOptionRadio": "ChangeOriginModal-module__lYh4dW__dialogOptionRadio",
  "dialogPanel": "ChangeOriginModal-module__lYh4dW__dialogPanel",
  "dialogTab": "ChangeOriginModal-module__lYh4dW__dialogTab",
  "dialogTabs": "ChangeOriginModal-module__lYh4dW__dialogTabs",
  "dialogTabsRoot": "ChangeOriginModal-module__lYh4dW__dialogTabsRoot",
  "drawer-footer-slide-up": "ChangeOriginModal-module__lYh4dW__drawer-footer-slide-up",
  "drawerBack": "ChangeOriginModal-module__lYh4dW__drawerBack",
  "drawerFooter": "ChangeOriginModal-module__lYh4dW__drawerFooter",
  "drawerFooterCol": "ChangeOriginModal-module__lYh4dW__drawerFooterCol",
  "drawerFooterConfirm": "ChangeOriginModal-module__lYh4dW__drawerFooterConfirm",
  "drawerHeader": "ChangeOriginModal-module__lYh4dW__drawerHeader",
  "drawerList": "ChangeOriginModal-module__lYh4dW__drawerList",
  "drawerOriginRow": "ChangeOriginModal-module__lYh4dW__drawerOriginRow",
  "drawerRegionRow": "ChangeOriginModal-module__lYh4dW__drawerRegionRow",
  "drawerRoot": "ChangeOriginModal-module__lYh4dW__drawerRoot",
  "drawerTitle": "ChangeOriginModal-module__lYh4dW__drawerTitle",
  "helperText": "ChangeOriginModal-module__lYh4dW__helperText",
  "popoverLoading": "ChangeOriginModal-module__lYh4dW__popoverLoading",
});
